<template>
  <path
    d="M5.5 5.00025C5.5 3.61948 6.61934 2.5 8 2.5C9.38066 2.5 10.5 3.61947 10.5 5.00023L10.5 7C10.5 7.27614 10.7239 7.5 11 7.5C11.2761 7.5 11.5 7.27615 11.5 7L11.5 5.00023C11.5 3.06729 9.93305 1.5 8 1.5C6.06695 1.5 4.5 3.0673 4.5 5.00025L4.5 7C4.5 7.27614 4.72385 7.5 5 7.5C5.27614 7.5 5.5 7.27615 5.5 7L5.5 5.00025Z"
    fill="#E2E2E2" />
  <path
    d="M5.5 10C5.50001 9.72386 5.27615 9.5 5.00001 9.5C4.72386 9.5 4.50001 9.72385 4.5 10L4.5 11.9998C4.5 13.9327 6.06695 15.5 8 15.5C9.93305 15.5 11.5 13.9327 11.5 11.9998L11.5 10C11.5 9.72386 11.2761 9.5 11 9.5C10.7239 9.5 10.5 9.72385 10.5 10L10.5 11.9998C10.5 13.3805 9.38066 14.5 8 14.5C6.61934 14.5 5.5 13.3805 5.5 11.9998L5.5 10Z"
    fill="#E2E2E2" />
</template>
